/**
 * Central catalog of all LLM tools
 *
 * To add a new tool:
 * 1. Create your tool file (e.g., myFeature.ts) using tools/template.ts as a guide
 * 2. Import it below
 * 3. Add it to the allTools object
 * 4. Optionally add a chartTransformer to generate charts from tool output (see template.ts)
 *
 */

import { accountTools } from './accounts';
import { businessTools } from './business';
import { chartTools } from './chart';
import { goalsTools } from './goals';
import { investmentsTools } from './investments';
import { netWorthTools } from './netWorth';
import { recurringTools } from './recurring';
import { reportTools } from './reports';
import { rulesTools } from './rules';
import { spendingTools } from './spending';
import { spendingPlanTools } from './spendingPlan';
import { suggestTools } from './suggest';
import { categoryTools, transactionTools } from './transactions';
import { watchlistTools } from './watchlist';

export const allTools = {
  ...accountTools,
  ...chartTools,
  ...spendingTools,
  ...spendingPlanTools,
  ...categoryTools,
  ...transactionTools,
  ...goalsTools,
  ...investmentsTools,
  ...netWorthTools,
  ...recurringTools,
  ...watchlistTools,
  ...rulesTools,
  ...reportTools,
  ...suggestTools,
  ...businessTools,
  // Add your new tools here:
  // ...myFeatureTools,
};
